import { Target, Wand2, Network, Presentation, ListChecks, Timer, ClipboardCheck, BookMarked } from "lucide-react";

const modules = [
  { icon: Target, phase: "Fase 1", title: "Attenzione", desc: "Non leggere, cerca. Entri nel testo con una domanda guida e una direzione precisa.", big: true },
  { icon: Wand2, phase: "Fase 2", title: "Elaborazione", desc: "Trasformi il contenuto e lo riscrivi con parole tue, semplici e chiare." },
  { icon: Network, phase: "Fase 3", title: "Collegamento", desc: "Esci dal testo e colleghi le idee a ciò che già sai." },
  { icon: Presentation, phase: "Fase 4", title: "Esposizione", desc: "Costruisci un discorso e spieghi senza dipendere dal libro.", big: true },
  { icon: ListChecks, phase: "Contenuti", title: "Esempi guidati", desc: "Esempi svolti per Medicina, Diritto ed Economia." },
  { icon: Timer, phase: "Pratica", title: "Esercizi guidati", desc: "Esercizi pronti per ogni fase, da fare sui tuoi testi." },
  { icon: ClipboardCheck, phase: "Applicazione", title: "Applicazione reale", desc: "Come applicare il metodo a un testo vero, passo passo." },
  { icon: BookMarked, phase: "Percorso", title: "Dalla teoria all'esame", desc: "Dai principi della comprensione fino all'esposizione all'esame." },
];

export default function Modules() {
  return (
    <section id="benefici" className="relative py-16 sm:py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5982c5]">Cosa c'è dentro</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1f2937]">
            Un percorso completo, dalla prima pagina all'esame
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-[#4b5563]">
            Il processo in 4 fasi più strumenti pratici pensati per superiori e università.
            Tutto applicabile subito ai tuoi testi reali.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {modules.map((m, i) => {
            const Icon = m.icon;
            return (
              <div
                key={i}
                className={`group bg-white rounded-3xl p-6 sm:p-7 border border-[#e5e7eb] shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(89,130,197,0.12)] hover:-translate-y-1 transition-all duration-300 ${
                  m.big ? "lg:col-span-2" : ""
                }`}
              >
                <div className="w-12 h-12 rounded-2xl bg-[#ecfef7] flex items-center justify-center group-hover:bg-[#f0d203] transition-colors duration-300">
                  <Icon size={24} className="text-[#5982c5] group-hover:text-[#1a1a1a] transition-colors" />
                </div>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.15em] text-[#f0d203]">{m.phase}</p>
                <h3 className="mt-1 font-heading text-xl font-bold text-[#1f2937]">{m.title}</h3>
                <p className="mt-2 text-[#4b5563] leading-relaxed">{m.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
